"use strict";
export default {
  summary(factorInvoice) {
    const debtor = factorInvoice.factor_broker && factorInvoice.factor_broker.name;
    const loadId = factorInvoice.load_id;
    if (debtor && loadId) {
      return `debtor: ${debtor} load id: ${loadId}`;
    } else if (debtor) {
      return `debtor: ${debtor}`;
    } else if (loadId) {
      return `load id: ${loadId}`;
    } else {
      return "unknown debtor/load";
    }
  }
};
